import { render, staticRenderFns } from "./oneShuttle.vue?vue&type=template&id=01b6a064&scoped=true&"
import script from "./oneShuttle.vue?vue&type=script&lang=js&"
export * from "./oneShuttle.vue?vue&type=script&lang=js&"
import style0 from "./oneShuttle.vue?vue&type=style&index=0&id=01b6a064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6a064",
  null
  
)

export default component.exports